
import {
    initialState as loaderInitialState,
    createLoaderReducer
} from '../../common/client/reducers/loader';

import { GET_OPSUB_ACTION_TYPE } from '../../sagas/opsub';

export const initialState = {
    ...loaderInitialState,
    opsubItems: null
};

export function getOpsubAddress(opsubItem) {
    let address = ''
    if (opsubItem.obec) {
        if (opsubItem.nazev_ulice) {
            address = address + `${opsubItem.nazev_ulice} `;
            if (opsubItem.cislo_domovni) {
                address = address + `${opsubItem.cislo_domovni}`;
            }
            if (opsubItem.cislo_orientacni) {
                address = address + `/${opsubItem.cislo_orientacni}`;
            }
        } else {
            if (opsubItem.cast_obce) {
                address = address + `${opsubItem.cast_obce}`;
            } else {
                if (opsubItem.obec) {
                    address = address + `${opsubItem.obec}`;
                }
            }
            if (opsubItem.cislo_domovni) {
                address = address + ` ${opsubItem.cislo_domovni}`;
            }
        }
        address = address + `, `;
        if (opsubItem.psc) {
            address = address + `${opsubItem.psc}`;
        }
        address = address + ` ${opsubItem.obec}`;
    }
    return address;
}

export function getOpsubName(opsubItem) {
    switch (opsubItem.opsub_type) {
        case 'OFO':
            let name = (opsubItem.prijmeni && opsubItem.jmeno)
                ? `${opsubItem.prijmeni} ${opsubItem.jmeno}`
                : `${opsubItem.nazev}`;
            if (opsubItem.titul_pred_jmenem) {
                name = `${opsubItem.titul_pred_jmenem} ${name}`;
            }
            if (opsubItem.titul_za_jmenem) {
                name = `${name}, ${opsubItem.titul_za_jmenem}`;
            }
            return name;
        case 'OPO':
            return `${opsubItem.nazev}`;
        case 'BSM':
            return `${opsubItem.nazev}`;
        default:
            return '-';
    }
}

export function getOpsubRcIco(opsubItem) {
    let rcico = '';
    if (opsubItem.rodne_cislo) {
        rcico = `rč: ${opsubItem.rodne_cislo}`;
    }
    if (opsubItem.ico) {
        rcico = `IČO: ${opsubItem.ico}`;
    }
    return rcico;
}

export function getOpsubItems(state) {
    return state.opsubItems
        ? state.opsubItems
        : [];
}

function processActionResult(state, action) {
    switch (action.data.result.operation) {
        case GET_OPSUB_ACTION_TYPE.DEFAULT:
            return {
                opsubItems: action.data.result.result.map(item => {
                    return {
                        ...item,
                        _name: getOpsubName(item),
                        _address: getOpsubAddress(item),
                        _rcico: getOpsubRcIco(item)
                    }
                })
            };
        default:
            return {};
    }
}

export default function createReducer(actionType) {
    const loaderReducer = createLoaderReducer(actionType);

    return (state = initialState, action) => {
        switch (action.type) {

            case actionType.DEFAULT:
                return {
                    ...state,
                    opsubItems: null
                };

            case actionType.SUCCESS:
                return {
                    ...state,
                    ...loaderReducer(state, action),
                    ...processActionResult(state, action, actionType)
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
